module.exports = __webpack_public_path__ + "images/psp/FeaturedContentImages/GolfCart/shutterstock.jpg";